import api from '../api';
class UserService {
    getMe() {
        return api.get(`/users/me`);
    }
    getNotifications({ page, limit }) {
        return api.get(`/notifications/pages?page=${page}&limit=${limit}`);
    }
    getNotification(notificationId) {
        return api.get(`/notifications/${notificationId}`);
    }
    getChatList() {
        return api.get(`/chats/my`);
    }
    getChatMessages({ chatId, skip }) {
        return api.get(`/messages/pages/${chatId}`, { params: { skip } });
    }
    readMessages(ids) {
        return api.patch('/messages/read', { ids });
    }
    createMessage({ chatId, message }) {
        return api.post('/messages', { chatId, message });
    }
    filterNotificationByDate(date) {
        return api.get(`/notifications/pages?date=${date}`);
    }
    filterNotificationByDateWithPages(date, page, limit) {
        return api.get(`/notifications/pages?page=${page}&limit=${limit}&date=${date}`);
    }
    markAsRead(data) {
        return api.post(`notifications/read/${data}`);
    }
    getImages() {
        return api.get(`users/image`);
    }
    getChat(user) {
        return api.post(`/chats`, { user: user });
    }
    guildChat(guildId) {
        return api.get(`/guilds/${guildId}/chat`);
    }
    setAvatar(filename) {
        return api.post(`/users/avatar`, { filename: filename });
    }
    getUserByAddress(stakeId) {
        return api.get(`/users/address/${stakeId}`);
    }
}
export default new UserService();
